import {
  AdgroupFormData,
  CampaignFormData,
  CALL_TO_ACTION,
  CTA_RULE,
  FullNormalFormData,
  AcoFormData,
  ADVANCED_CREATIVE_TYPE_MAP,
  NormalCreative
} from '@tt4b/ttam-enums';
import { useStdCreativeAdgroupIs, useCreativeIs, useStdInventoryFlow } from '@tt4b/ttam-hooks';
import { Ref, computed } from '@vue/composition-api';

export function useIsBrandLiftStudyCreative(options: { creativeData: Ref<Partial<FullNormalFormData & AcoFormData>> }) {
  return computed(
    () => options.creativeData.value?.advancedCreativeType === ADVANCED_CREATIVE_TYPE_MAP.BRAND_LIFT_STUDY
  );
}

export function useSelectPropsOptions(options: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  creativeData: Ref<Partial<FullNormalFormData & AcoFormData>>;
}) {
  const { adgroupData, campaignData, creativeData } = options;

  const isBrandLiftStudyCreative = useIsBrandLiftStudyCreative({
    creativeData,
  });
  // 是否是提问类型的BLS创意
  const isQuestionnaireOptimizationCreative = computed(
    () => creativeData.value?.advancedCreativeType === ADVANCED_CREATIVE_TYPE_MAP.QUESTIONNAIRE_OPTIMIZATION
  );

  const { isEngagement, isAco, isLiveAds } = useStdCreativeAdgroupIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });

  const ctaList = computed(() => {
    let list = CALL_TO_ACTION || [];
    // 如果不是engagement，就需要过滤掉仅支持engagement的CTA
    if (!isEngagement.value) {
      list = list.filter(({ id }) => !CTA_RULE.ONLY_ENGAGEMENT_USEABLE_CTA_LIST.includes(id));
    }
    if (!isLiveAds.value) {
      list = list.filter(({ id }) => !CTA_RULE.ONLY_LIVEADS_CTA_LIST.includes(id));
    }
    // 如果是BLS创意 只展示BLS创意相关的list
    if (isBrandLiftStudyCreative.value && !isAco.value) {
      return list.filter(({ id }) => CTA_RULE.ONLY_BLS_ENABLE_CTA_IDS.includes(id));
    }
    // TODO: 这个<提问类型的BLS创意>还需要一个专业的名词
    // 如果是提问类型的BLS创意 不展示CTA
    if (isQuestionnaireOptimizationCreative.value && !isAco.value) {
      return [];
    }

    return list.filter(({ id }) => !CTA_RULE.ONLY_BLS_ENABLE_CTA_IDS.includes(id));
  });

  return {
    options: ctaList,
  };
}

export function useSelectPropsDisabled(options: {
  creativeData: Ref<Partial<FullNormalFormData & AcoFormData>>;
  isDisabledCreative: Ref<boolean>;
}) {
  const isBrandLiftStudyCreative = useIsBrandLiftStudyCreative({
    creativeData: options.creativeData,
  });

  const disbaledSelect = computed(() => options.isDisabledCreative.value || isBrandLiftStudyCreative.value);

  return {
    disabled: disbaledSelect,
  };
}

export function useLabelHintPropsLinkVisible(options: {
  adgroupData: Ref<AdgroupFormData>;
  normalCreativeData: Ref<NormalCreative>;
  createMode: Ref<string>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { isNative } = useCreativeIs({
    adgroupFormData: options.adgroupData,
    campaignFormData: options.campaignData,
    createMode: options.createMode,
    normalCreativeData: options.normalCreativeData,
  });

  const { hasTiktokAdNetwork } = useStdInventoryFlow({
    adgroupFormData: options.adgroupData,
  });

  const includePanglePreview = computed(() => {
    if (isNative.value) {
      return false;
    }

    return Boolean(hasTiktokAdNetwork.value);
  });

  return {
    visible: includePanglePreview,
  };
}
